module.exports = __webpack_public_path__ + "img/users-icon-active.473318cd.svg";